import {createContext,useContext,type ReactNode} from "react";
import type {UnitsSettings} from "./units";
const UnitsContext=createContext<UnitsSettings|null>(null);
/** Host supplies effective units; fields keep their existing fallback when no host is present. */
export function UnitsProvider({value,children}:{value:UnitsSettings|null;children:ReactNode}){return <UnitsContext.Provider value={value}>{children}</UnitsContext.Provider>;}
export function useUnitsOptional(){return useContext(UnitsContext);}
